import React, { useEffect, useState, useRef } from "react";
import { useAuth, db } from "../context/authContext";
import { doc, onSnapshot, updateDoc } from "firebase/firestore";
import { useRPM } from "../hooks/useRPM";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import Reloj from "./Reloj";
import Distancia from "./Distancia";
import Calorias from "./Calorias";
import logo from "../assets/Logo.png";



const EMOJIS = [
  "❤️",
  "🔥",
  "💪",
  "🦵",
  "🦿",
  "👏",
  "🚀",
  "👍",
  "🏆",
  "🥵",
  "⚡",
  "👊",
  "💦",
  "🐘",
  "😈",
  "🤟",
  "🙌",
  "😮‍💨",
  "🫶",
  "🚴",
  "🎉",
  "⭐",
  "🤩",
  "💥",
  "✅",
  "😎",
];

// 🔹 Nombres fake (solo 9 usuarios)
const NOMBRES_FAKE = [
  "Laura", "Carlos", "Ana",
  "David", "Sofía", "Pedro",
  "Marta", "Sergio", "Lucía"
];

export function HomeUser() {

  const { logout, EstadoLogout, addInfoGym, Estado } = useAuth();

  const [personas, setPersonas] = useState([]);
  const [miEmoji, setMiEmoji] = useState("");
  const navigate = useNavigate();

  // 👇 ahora sí traes el usuario del contexto
  const { user } = useAuth();

  // Estados de puntos (igual que en Home.js)
  const [puntosSesion, setPuntosSesion] = useState(0);   // progreso actual
  const [puntosLocal, setPuntosLocal] = useState(0);     // buffer en memoria
  const [puntosRanking, setPuntosRanking] = useState(0); // emojis lanzados
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalType, setModalType] = useState("success"); // "success" | "error"
  const gimnasio = JSON.parse(localStorage.getItem("gimnasio")) || "free";
  const claseId = JSON.parse(localStorage.getItem("claseId")) || "free";

  // 👇 estado local para tokens
  const [tokens, setTokens] = useState(0);
  const [nombreUsuario, setNombreUsuario] = useState("Yo");

  //Validar que estoy en homeuser

  // justo después de este bloque que ya tienes:
  useEffect(() => {
    localStorage.setItem("lastPage", "homeuser");
  }, []);

  // 👇 guardar el contexto en Firestore y marcar activo al entrar
  useEffect(() => {
    const activarUsuario = async () => {
      if (!user?.uid) return;

      try {
        const userRef = doc(db, "usuarios", user.uid);
        await updateDoc(userRef, {
          activo: true,
          ultimoContexto: "/homeuser",
        });
        console.log("🟢 Usuario activo en Firestore + contexto /homeuser");
      } catch (err) {
        console.error("❌ Error al activar usuario en HomeUser:", err);
      }
    };

    activarUsuario();
  }, [user]);

  // 👇 marcar inactivo al cerrar pestaña/ventana
  useEffect(() => {
    const handleBeforeUnload = async () => {
      try {
        if (user?.uid) {
          const userRef = doc(db, "usuarios", user.uid);
          await updateDoc(userRef, { activo: false });
          console.log("🚪 Usuario marcado inactivo al cerrar HomeUser");
        }
      } catch (err) {
        console.error("❌ Error al marcar inactivo en HomeUser:", err);
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [user]);


  // suscripción a Firestore → tokens en vivo
  useEffect(() => {
    if (!user?.uid) return;
    const userRef = doc(db, "usuarios", user.uid);
    const unsubscribe = onSnapshot(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();
        setTokens(data.tokens || 0);
        localStorage.setItem("Tokens", data.tokens || 0);
        setNombreUsuario(data.nombre || user.displayName || "Yo");
      }
    });
    return () => unsubscribe();
  }, [user]);


  useEffect(() => {
    const syncHandler = (event) => {
      if (event.key === "cerrarClase") {
        console.log("🔄 Clase cerrada en otra pestaña");
        navigate("/comprobacion");
      }
    };
    window.addEventListener("storage", syncHandler);
    return () => window.removeEventListener("storage", syncHandler);
  }, [navigate]);


  // 🔹 RPM usuario
  const { rpm, started, startDetection, stopDetection } = useRPM();

  // 🔹 Inicializar fake
  useEffect(() => {
    const inicial = NOMBRES_FAKE.map((nombre) => ({
      nombre,
      rpm: Math.floor(Math.random() * 40) + 60,
      emojiActivo: null,
    }));
    setPersonas(inicial);
  }, []);

  // 🔹 Actualizar cada 8s
  useEffect(() => {
    const interval = setInterval(() => {
      setPersonas((prev) =>
        prev.map((p) => {
          const nuevaRpm = Math.floor(Math.random() * 40) + 60;
          const lanzarEmoji = Math.random() < 0.4;
          const emojiRandom = lanzarEmoji
            ? EMOJIS[Math.floor(Math.random() * EMOJIS.length)]
            : null;
          return { ...p, rpm: nuevaRpm, emojiActivo: emojiRandom };
        })
      );
      setTimeout(() => {
        setPersonas((prev) => prev.map((p) => ({ ...p, emojiActivo: null })));
      }, 5000);
    }, 8000);

    return () => clearInterval(interval);
  }, []);

  // 🔹 Emojis propios con puntos
  const handleEmoji = (emoji) => {
    setMiEmoji(emoji);
    setTimeout(() => setMiEmoji(""), 5000);

    // ➕ sumar 1 al contador de emojis lanzados
    setPuntosRanking((prev) => prev + 1);

    // ➕ sumar 0.1 puntos a la sesión
    setPuntosLocal((prev) => {
      const nuevosLocal = parseFloat((prev + 0.1).toFixed(1));
      const totalSesion = parseFloat((puntosSesion + nuevosLocal).toFixed(1));

      console.log("👉 Local:", nuevosLocal, "Total sesión:", totalSesion);

      // 🔹 Avisar con modal en modo Free
      checkBonusFree(totalSesion);

      return nuevosLocal;
    });

  };

  // nuevo estado
  const ultimoUmbralRef = useRef(0);

  const checkBonusFree = (puntosTotalesSesion) => {
    const totalEntero = Math.floor(puntosTotalesSesion);
    const umbral = Math.floor(totalEntero / 1000) * 1000;

    if (umbral > 0 && umbral !== ultimoUmbralRef.current) {
      ultimoUmbralRef.current = umbral; // ✅ guardamos el nuevo umbral inmediatamente
      setModalMessage(
        `⚡ Has alcanzado ${umbral} puntos. En Premium esto se convierte en tokens 🎟️`
      );
      setModalOpen(true);
    }
  };

  // 🔹 Guardar entreno local (FREE)
  const handleGuardar = () => {
    const nuevoEntreno = {
      fecha: new Date().toLocaleDateString(),
      duracion: document.getElementById("reloj-duracion")?.innerText || "00:00",
      distancia: document.getElementById("distancia-recorrido")?.innerText || "0 Km",
      calorias: document.getElementById("calorias-gastadas")?.innerText || "0 Kcal",
      cadenciaMedia: rpm,
      emojis: puntosRanking,  // 👈 guarda emojis lanzados
      puntos: Math.floor(puntosSesion + puntosLocal),
      modo: "Free",
    };

    // 🔍 Cargar historial y comprobar duplicados
    const entrenos = JSON.parse(localStorage.getItem("historialEntrenos") || "[]") || [];

    const yaExiste = entrenos.some(
      (e) =>
        e.fecha === nuevoEntreno.fecha &&
        e.modo === "Free"
    );

    if (yaExiste) {
      setModalType("error");
      setModalMessage("⚠️ Este entreno ya fue guardado.");
      setModalOpen(true);
      return; // 👈 salimos sin guardar nada
    }

    // ✅ Guardar solo si no existe
    entrenos.push(nuevoEntreno);
    localStorage.setItem("historialEntrenos", JSON.stringify(entrenos));

    setModalType("success");
    setModalMessage("✅ Entreno guardado correctamente.");
    setModalOpen(true);

    navigate("/resumentreno");
  };


  // 🔹 Otros botones
  const handleRanking = () =>
    navigate("/Ranking", {
      state: { tipoRanking: "grupo" },
    });
  const handleCerrarClase = async () => {
    try {
      if (user?.uid) {
        await EstadoLogout();       // 🔹 actualiza en Firestore

      }

      localStorage.removeItem("gimnasio");
      localStorage.setItem("cerrarClase", Date.now()); // 🔄 notificar a todas las pestañas
      navigate("/comprobacion");
    } catch (err) {
      console.error("❌ Error al cerrar clase:", err);
    }
  };





  const handleLogout = async () => {
    try {
      if (user?.uid) {
        await EstadoLogout();
      }

      setPuntosSesion(0);
      setPuntosLocal(0);
      stopDetection();
      localStorage.removeItem("gimnasio");

      // 🔄 Notificar a otras pestañas
      localStorage.setItem("logout", Date.now());

      // 🚪 Cerrar sesión Firebase (esto propaga en todas las pestañas con onAuthStateChanged)
      await logout();

      console.log("✅ Logout completo desde HomeUser");
    } catch (err) {
      console.error("❌ Error en logout:", err);
    }
  };



  // 🔹 Efecto para sumar puntos automáticamente cada 5 minutos en base a RPM
  useEffect(() => {
    if (!started) return;

    const interval = setInterval(() => {
      if (rpm > 0) {
        const puntosGanados = Math.floor(rpm / 10); // ej: 80rpm = 8 puntos

        setPuntosLocal((prev) => {
          const nuevosLocal = prev + puntosGanados;
          const totalSesion = puntosSesion + nuevosLocal;

          console.log(`⏱️ AutoPuntos: +${puntosGanados} (RPM=${rpm}) → Sesión=${totalSesion}`);
          // 🔹 Avisar con modal en modo Free

          checkBonusFree(totalSesion);
          return nuevosLocal;
        });
      }
    }, 1 * 60 * 1000); //guardamos cada 1 minutos

    return () => clearInterval(interval);
  }, [started, rpm, puntosSesion]);

  return (
    <div className="w-screen min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white">
      <div className="w-full max-w-md mx-auto px-4 pt-5 pb-10">

        {/* CABECERA */}
        <div className="mb-5">
          <div className="flex items-center justify-between gap-3">
            <img
              src={logo}
              alt="RPM Coach"
              className="w-28 h-auto"
            />

            <motion.button
              type="button"
              whileTap={{ scale: 0.95 }}
              onClick={() => navigate("/comprar-tokens")}
              className="
                flex
                items-center
                gap-2
                px-4
                py-2
                rounded-full
                border
                border-yellow-400/20
                bg-yellow-400/10
                text-sm
                font-bold
                text-yellow-300
                shadow-lg
              "
            >
              <span>🎟️</span>
              <span>{tokens}</span>
              <span className="text-yellow-200">+</span>
            </motion.button>
          </div>

          <div className="mt-4 p-4 rounded-3xl border border-white/10 bg-white/10 shadow-xl backdrop-blur-lg">
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="text-xs uppercase tracking-widest text-gray-400">
                  Modo libre
                </p>

                <h1 className="mt-1 text-lg font-extrabold text-white">
                  Entrena a tu ritmo
                </h1>

                <p className="mt-1 text-sm text-gray-400">
                  Pedalea, suma puntos y mejora tu sesión.
                </p>
              </div>

              <div className="shrink-0 px-3 py-2 rounded-full border border-green-400/20 bg-green-500/10 text-xs font-bold text-green-400">
                <span className="inline-block w-2 h-2 mr-2 rounded-full bg-green-400" />
                ACTIVO
              </div>
            </div>
          </div>
        </div>



        {/* PROGRESO DE PUNTOS */}
        <div className="mb-6 p-5 rounded-3xl border border-green-400/20 bg-green-500/10 shadow-xl">
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="text-xs uppercase tracking-widest text-green-300">
                Progreso de sesión
              </p>

              <p className="mt-1 text-2xl font-extrabold text-white">
                {Math.floor(puntosSesion + puntosLocal)} puntos
              </p>

              <p className="mt-1 text-sm text-gray-300">
                En Premium, cada 1000 puntos puede darte tokens.
              </p>
            </div>

            <div className="w-12 h-12 flex items-center justify-center rounded-2xl bg-green-500/20 text-2xl">
              🏆
            </div>
          </div>

          <div className="mt-4 w-full h-3 rounded-full bg-black/30 overflow-hidden">
            <motion.div
              initial={{ width: 0 }}
              animate={{
                width: `${(((puntosSesion + puntosLocal) % 1000) / 1000) * 100
                  }%`,
              }}
              transition={{ duration: 0.4 }}
              className="h-full rounded-full bg-gradient-to-r from-green-400 to-emerald-500"
            />
          </div>

          <div className="mt-2 flex justify-between text-xs text-gray-400">
            <span>
              {Math.floor(puntosSesion + puntosLocal) % 1000} / 1000
            </span>

            <span>Próximo objetivo</span>
          </div>
        </div>

        {/* MÉTRICAS */}
        <div className="grid grid-cols-3 gap-2 mb-5">
          <div className="px-2 py-4 rounded-2xl border border-white/10 bg-white/10 text-center shadow-lg">
            <p className="mb-2 text-lg">⏱️</p>

            <div
              id="reloj-duracion"
              className="text-lg font-extrabold text-white"
            >
              <Reloj />
            </div>

            <p className="mt-1 text-xs text-gray-400">
              Duración
            </p>
          </div>

          <div className="px-2 py-4 rounded-2xl border border-white/10 bg-white/10 text-center shadow-lg">
            <p className="mb-2 text-lg">🚴</p>

            <div
              id="distancia-recorrido"
              className="text-lg font-extrabold text-blue-400"
            >
              <Distancia rpm={rpm} />
            </div>

            <p className="mt-1 text-xs text-gray-400">
              Distancia
            </p>
          </div>

          <div className="px-2 py-4 rounded-2xl border border-white/10 bg-white/10 text-center shadow-lg">
            <p className="mb-2 text-lg">🔥</p>

            <div
              id="calorias-gastadas"
              className="text-lg font-extrabold text-orange-400"
            >
              <Calorias rpm={rpm} />
            </div>

            <p className="mt-1 text-xs text-gray-400">
              Calorías
            </p>
          </div>
        </div>

        {/* RENDIMIENTO EN VIVO */}
        <div className="relative mb-5 overflow-hidden rounded-3xl border border-white/10 bg-white/10 p-5 shadow-2xl backdrop-blur-lg">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-xs uppercase tracking-widest text-gray-400">
                Rendimiento en vivo
              </p>

              <h2 className="mt-1 text-lg font-extrabold">
                Cadencia actual
              </h2>
            </div>

            <span className="px-3 py-1.5 rounded-full border border-white/10 bg-black/20 text-xs text-gray-300">
              {nombreUsuario}
            </span>
          </div>

          <div className="mt-5 flex justify-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.92 }}
              animate={{ opacity: 1, scale: 1 }}
              className="
                relative
                w-56
                h-56
                flex
                flex-col
                items-center
                justify-center
                rounded-full
                border-8
                border-white/10
                bg-black/20
                shadow-2xl
              "
            >
              <p className="text-6xl font-extrabold text-green-400">
                {rpm}
              </p>

              <p className="mt-1 text-xs uppercase tracking-widest text-gray-400">
                RPM
              </p>

              <div className="mt-4 px-4 py-2 rounded-full border border-white/10 bg-white/10 text-xs text-gray-300">
                {started ? "Pedaleando" : "Sensores apagados"}
              </div>

              {miEmoji && (
                <motion.div
                  key={miEmoji}
                  initial={{
                    opacity: 0,
                    scale: 0.4,
                    y: 20,
                  }}
                  animate={{
                    opacity: 1,
                    scale: 1.3,
                    y: -45,
                  }}
                  transition={{ duration: 0.55 }}
                  className="absolute z-20 text-6xl pointer-events-none"
                >
                  {miEmoji}
                </motion.div>
              )}
            </motion.div>
          </div>

          <p className="mt-6 text-center text-xs text-gray-400">
            Mantén la pantalla encendida para actualizar tus RPM.
          </p>
        </div>

        {/* ACTIVAR SENSORES */}
        {!started && (
          <motion.button
            type="button"
            whileTap={{ scale: 0.98 }}
            onClick={startDetection}
            className="
              w-full
              mb-5
              flex
              items-center
              justify-between
              gap-3
              px-4
              py-3
              rounded-2xl
              border
              border-blue-400/20
              bg-blue-500/10
              text-left
              shadow-lg
            "
          >
            <div>
              <p className="text-sm font-bold text-blue-300">
                Activa los sensores
              </p>

              <p className="mt-1 text-xs text-gray-400">
                Necesarios para detectar tus RPM.
              </p>
            </div>

            <span className="px-4 py-2 rounded-xl bg-blue-500 text-xs font-bold text-white">
              Activar
            </span>
          </motion.button>
        )}


        {/* REACCIONES */}
        <div className="mb-6">
          <div className="flex items-center justify-between mb-3">
            <div>
              <p className="text-xs uppercase tracking-widest text-gray-400">
                Reacciones
              </p>

              <h2 className="mt-1 text-lg font-extrabold">
                Envía energía al grupo
              </h2>
            </div>

            <span className="text-xs text-gray-400">
              Desliza
            </span>
          </div>

          <div
            className="
              flex
              gap-3
              overflow-x-auto
              px-2
              py-3
              rounded-3xl
              border
              border-white/10
              bg-white/10
              scroll-smooth
              snap-x
              snap-mandatory
              no-scrollbar
            "
          >
            {EMOJIS.map((emoji) => (
              <motion.button
                key={emoji}
                type="button"
                whileTap={{ scale: 0.8 }}
                onClick={() => handleEmoji(emoji)}
                className="
                  min-w-[64px]
                  w-[64px]
                  h-[64px]
                  shrink-0
                  flex
                  items-center
                  justify-center
                  rounded-full
                  border
                  border-white/10
                  bg-white/10
                  text-3xl
                  shadow-md
                  snap-center
                  active:bg-white/20
                "
              >
                {emoji}
              </motion.button>
            ))}
          </div>
        </div>


        {/* OTROS CICLISTAS */}
        <div className="mb-6">
          <div className="flex items-end justify-between mb-3">
            <div>
              <p className="text-xs uppercase tracking-widest text-gray-400">
                Comunidad
              </p>

              <h2 className="mt-1 text-lg font-extrabold">
                Otros ciclistas
              </h2>
            </div>

            <span className="text-xs text-green-400">
              ● En movimiento
            </span>
          </div>

          <div className="grid grid-cols-3 gap-3">
            {personas.map((persona, index) => (
              <motion.div
                key={`${persona.nombre}-${index}`}
                initial={{ opacity: 0, y: 15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05 }}
                className="
                  relative
                  min-h-[120px]
                  flex
                  flex-col
                  items-center
                  justify-center
                  rounded-2xl
                  border
                  border-white/10
                  bg-white/10
                  p-3
                  text-center
                  shadow-lg
                "
              >
                <div className="w-9 h-9 flex items-center justify-center rounded-full bg-blue-500/15 text-sm font-bold text-blue-300">
                  {persona.nombre?.charAt(0)?.toUpperCase()}
                </div>

                <p className="mt-2 w-full truncate text-xs font-semibold text-white">
                  {persona.nombre}
                </p>

                <p className="mt-1 text-xl font-extrabold text-blue-400">
                  {persona.rpm}
                </p>

                <p className="text-[10px] uppercase tracking-wider text-gray-500">
                  RPM
                </p>

                {persona.emojiActivo && (
                  <motion.div
                    initial={{ opacity: 0, scale: 0.5 }}
                    animate={{ opacity: 1, scale: 1 }}
                    className="absolute -top-3 -right-1 text-3xl"
                  >
                    {persona.emojiActivo}
                  </motion.div>
                )}
              </motion.div>
            ))}
          </div>
        </div>

        {/* PREMIUM */}
        <div className="mb-6 relative overflow-hidden rounded-3xl border border-yellow-400/20 bg-gradient-to-br from-yellow-500/20 via-orange-500/10 to-white/10 p-5 shadow-xl">
          <div className="flex items-start justify-between gap-4">
            <div>
              <p className="text-xs uppercase tracking-widest text-yellow-300">
                Modo Premium
              </p>

              <h2 className="mt-1 text-lg font-extrabold">
                Vive la clase completa
              </h2>

              <p className="mt-2 text-sm leading-6 text-gray-300">
                Entra en canales con instructor, comparte reacciones en directo
                y envía propinas.
              </p>
            </div>

            <div className="w-12 h-12 shrink-0 flex items-center justify-center rounded-2xl bg-yellow-400/20 text-2xl">
              ⚡
            </div>
          </div>

          <motion.button
            type="button"
            whileTap={{ scale: 0.97 }}
            onClick={handleCerrarClase}
            className="
              w-full
              mt-5
              py-3
              rounded-2xl
              bg-gradient-to-r
              from-yellow-400
              to-orange-500
              font-extrabold
              text-black
              shadow-lg
            "
          >
            Explorar canales
          </motion.button>
        </div>

        {/* ACCIONES */}
        <div className="mb-6">
          <motion.button
            type="button"
            whileTap={{ scale: 0.98 }}
            onClick={handleGuardar}
            className="
              w-full
              py-4
              rounded-2xl
              bg-gradient-to-r
              from-green-400
              to-emerald-600
              text-white
              font-extrabold
              shadow-xl
            "
          >
            ✅ Guardar entreno
          </motion.button>

          <div className="grid grid-cols-2 gap-3 mt-3">
            <motion.button
              type="button"
              whileTap={{ scale: 0.97 }}
              onClick={handleRanking}
              className="
                py-4
                rounded-2xl
                border
                border-blue-400/20
                bg-blue-500/10
                text-blue-300
                font-bold
                shadow-lg
              "
            >
              🏆 Ranking
            </motion.button>

            <motion.button
              type="button"
              whileTap={{ scale: 0.97 }}
              onClick={() => navigate("/historial")}
              className="
                py-4
                rounded-2xl
                border
                border-purple-400/20
                bg-purple-500/10
                text-purple-300
                font-bold
                shadow-lg
              "
            >
              📊 Historial
            </motion.button>
          </div>

          <div className="mt-5 p-4 rounded-3xl border border-white/10 bg-white/5">
            <p className="mb-3 text-xs uppercase tracking-widest text-gray-500">
              Sesión
            </p>

            <motion.button
              type="button"
              whileTap={{ scale: 0.98 }}
              onClick={handleCerrarClase}
              className="
                w-full
                py-3
                rounded-xl
                border
                border-orange-400/20
                bg-orange-500/10
                text-orange-300
                font-bold
              "
            >
              🚪 Salir del modo libre
            </motion.button>

            <button
              type="button"
              onClick={handleLogout}
              className="w-full mt-2 py-3 text-sm font-semibold text-red-400"
            >
              Cerrar sesión
            </button>
          </div>
        </div>

        {/* MODAL */}
        {modalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 px-4 backdrop-blur-sm">
            <motion.div
              initial={{
                opacity: 0,
                scale: 0.9,
                y: 15,
              }}
              animate={{
                opacity: 1,
                scale: 1,
                y: 0,
              }}
              className="
                w-full
                max-w-sm
                p-6
                rounded-3xl
                border
                border-white/10
                bg-gray-900
                text-center
                shadow-2xl
              "
            >
              <div
                className={`
                  w-14
                  h-14
                  mx-auto
                  flex
                  items-center
                  justify-center
                  rounded-2xl
                  text-2xl
                  ${modalType === "error"
                    ? "bg-red-500/20"
                    : "bg-yellow-500/20"
                  }
                `}
              >
                {modalType === "error" ? "⚠️" : "⚡"}
              </div>

              <h2
                className={`
                  mt-4
                  text-lg
                  font-extrabold
                  ${modalType === "error"
                    ? "text-red-400"
                    : "text-yellow-300"
                  }
                `}
              >
                {modalMessage}
              </h2>

              {modalType !== "error" && (
                <motion.button
                  type="button"
                  whileTap={{ scale: 0.97 }}
                  onClick={() => navigate("/comprar-tokens")}
                  className="
                    w-full
                    mt-6
                    px-4
                    py-3
                    rounded-2xl
                    bg-gradient-to-r
                    from-yellow-400
                    to-orange-500
                    text-black
                    font-extrabold
                  "
                >
                  🚀 Ver opciones Premium
                </motion.button>
              )}

              <button
                type="button"
                onClick={() => setModalOpen(false)}
                className="
                  w-full
                  mt-3
                  px-4
                  py-3
                  rounded-2xl
                  border
                  border-white/10
                  bg-white/5
                  text-white
                  font-bold
                "
              >
                {modalType === "error"
                  ? "Entendido"
                  : "Seguir en modo libre"}
              </button>
            </motion.div>
          </div>
        )}

        <p className="text-center text-xs italic text-gray-500">
          You'll Never Train Alone 🚴‍♂️🔥
        </p>
      </div>
    </div>
  );
}

export default HomeUser;